import { Injectable } from '@angular/core';

import { GetEventByIdRequest, GetEventRequest } from '@aoe/client';
import { Observable } from 'rxjs';
import { EventDetailResponse, EventListResponse } from 'src/app/core/interfaces/EventsResponse.interface';
import { environment } from '../../../environments/environment';
import { RegistrationResponse } from '../interfaces/RegistrationResponse.interface';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class EventService extends ApiService {

  getEvents(filters?: GetEventRequest): Observable<EventListResponse> {
    return this.get<EventListResponse>('event', filters);
  }

  getEventByID(payload: GetEventByIdRequest): Observable<EventDetailResponse> {
    return this.get<EventDetailResponse>(`event/${payload.id}`);
  }

  getEventsRegistredList(eventId: string): Observable<RegistrationResponse> {
    return this.get<RegistrationResponse>(`event/${eventId}/registred-list`);
  }

  getPictureLink(eventId: string) {
    return `${environment.apiUrl}/event/${eventId}/picture`;
  }
}
